import { BaseMessage } from './base-message';

export class Warning extends BaseMessage {
    override get type(): string {
        return 'warning';
    }
}
